import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { AppBar, Toolbar } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';

const useStyles = makeStyles(() => ({
  root: { boxShadow: 'none' }
}));

const Topbar = props => {
  const { className, ...rest } = props;

  const classes = useStyles();

  function getImage() {
    const modulo = sessionStorage.getItem('modulo');

    let imagePath = '';

    if (modulo == 37) {
      imagePath = '/images/logocliappcli.png';
    } else {
      console.log('Não houve correspondência!');

      imagePath = '/images/logos/logo--white.png'; // caminho padrão se não houver correspondência
    }

    return imagePath;
  };

  return (
    <AppBar
      {...rest}
      className={clsx(classes.root, className)}
      color="primary"
      position="fixed"
    >
      <Toolbar>
        <RouterLink to="/">
          <img
            alt="Logo"
            src={getImage()}
          />
        </RouterLink>
      </Toolbar>
    </AppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string
};

export default Topbar;